import Axios from "../api/axios";
import createSelectByCountry from "../helpers/_createSelectByCounty";
import TabBlock from "../parts/tab_blocks";
import Modal from "../parts/modals";

const _axios = new Axios();

document.addEventListener("DOMContentLoaded", () => {
    const agencyTabs = document.querySelector(".js-agency-tabs");
    const modalAddNote = document.getElementById("modal-add-note");
    if (agencyTabs) {
        new TabBlock(agencyTabs).init();
    }

    if (modalAddNote) {
        const modal = new Modal(modalAddNote);
        modal.init();
    }
});

// Select coutny event

const _counrySelect = document.querySelector(".js-agency-select-country");
const _selectWrap = document.querySelector("#js-form-field--agency-city");
const _countrySelectCreateForm = document.querySelector(
    ".js-agency-select-country--create"
);

function initEditCityField(country_id, city_id, _selectWrap) {
    try {
        if (country_id) {
            _axios.get(`/api/countries/${country_id}`).then((res) => {
                createSelectByCountry(res.data, _selectWrap, city_id);
            });
        }
    } catch (err) {
        console.error("initEditCityField error", err);
    }
}

if (_counrySelect) {
    const data_id_country = _selectWrap.dataset.idCountry;
    const data_id_city = _selectWrap.dataset.idCity;

    if (data_id_country && data_id_city) {
        initEditCityField(data_id_country, data_id_city, _selectWrap);
    }
    try {
        _counrySelect.addEventListener("change", (e) => {
            const country_id = e.target.value;
            const parentWrap = _selectWrap.closest(".hide");
            if (country_id) {
                _axios.get(`/api/countries/${country_id}`).then((res) => {
                    createSelectByCountry(res.data, _selectWrap);
                    if (parentWrap) {
                        parentWrap.classList.remove("hide");
                    }
                });
            }
        });
    } catch (err) {
        console.error(err);
    }
}

if (_countrySelectCreateForm) {
    const parentWrap = _selectWrap.closest(".hide");

    _axios.get(`/api/countries/230`).then((res) => {
        createSelectByCountry(res.data, _selectWrap);
        if (parentWrap) {
            parentWrap.classList.remove("hide");
        }
    });
}

// Create note
/*
const formCreateNote = document.querySelector("form.form-agency-new-note");
const notesWrap = document.getElementById("notes-wrap--agency");

if (formCreateNote) {
    formCreateNote.addEventListener("submit", (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);

        const subject = formData.get("subject-input");
        const note = formData.get("note-input");
        const forAdmin = formData.get("only-for-admin");
        if (notesWrap) {
            createNote(notesWrap, {
                title: subject,
                text: note,
                forAdmin: forAdmin,
                date: new Date().toDateString(),
            });
        }
        if (document.querySelector("button[data-close]")) {
            document.querySelector("button[data-close]").click();
            e.target.reset();
        }
    });
}*/
